define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LocalStorage = void 0;
    class LocalStorage {
        constructor(namespace) {
            this.namespace = namespace;
            this.storage = window.localStorage;
        }
        get(key) {
            try {
                const storageObject = this.getStorageObject();
                const value = storageObject[key];
                return value ? Promise.resolve(value) : Promise.resolve(null);
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
        put(key, value) {
            try {
                const storageObject = this.getStorageObject();
                storageObject[key] = value;
                this.storage.setItem(this.namespace, JSON.stringify(storageObject));
                return Promise.resolve();
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
        delete(key) {
            try {
                const storageObject = this.getStorageObject();
                delete storageObject[key];
                this.storage.setItem(this.namespace, JSON.stringify(storageObject));
                return Promise.resolve(true);
            }
            catch (e) {
                return Promise.reject(e);
            }
        }
        clear() {
            this.storage.removeItem(this.namespace);
            return Promise.resolve(true);
        }
        getStorageObject() {
            const namespaceStorage = this.storage.getItem(this.namespace);
            if (!namespaceStorage) {
                return {};
            }
            return JSON.parse(namespaceStorage);
        }
    }
    exports.LocalStorage = LocalStorage;
});
